module.exports = __webpack_public_path__ + "img/u9.a6effc25.png";